import { render, staticRenderFns } from "./ResearchAccordion.vue?vue&type=template&id=5b7988b0"
import script from "./ResearchAccordion.vue?vue&type=script&lang=js"
export * from "./ResearchAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7988b0')) {
      api.createRecord('5b7988b0', component.options)
    } else {
      api.reload('5b7988b0', component.options)
    }
    module.hot.accept("./ResearchAccordion.vue?vue&type=template&id=5b7988b0", function () {
      api.rerender('5b7988b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/ResearchAccordion.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchAccordion.vue
// module id = 415
// module chunks = 0